import { Injectable } from '@angular/core';
import { RideErrorConstants } from '@uzurv/clara';

@Injectable({
  providedIn: 'root'
})
export class ErrorTranslationService {
  constructor() {}

  translateErrorMessage(errorMessage: string): string {
    if (RideErrorConstants.LOCATION_NOT_WITHIN_GEOFENCE.test(errorMessage)) {
      const pickupOutsidePickupError = RideErrorConstants.PICKUP_OUTSIDE_PICKUP_GEOFENCE.test(errorMessage);
      const dropoffOutsideDropoffError = RideErrorConstants.DROPOFF_OUTSIDE_DROPOFF_GEOFENCE.test(errorMessage);
      const pickupOutsidePickupAndDropoffError = RideErrorConstants.PICKUP_OUTSIDE_PICKUP_AND_DROPOFF_GEOFENCE.test(errorMessage);
      const dropoffOutsidePickupAndDropoffError = RideErrorConstants.DROPOFF_OUTSIDE_PICKUP_AND_DROPOFF_GEOFENCE.test(errorMessage);
      const pickupAndDropoffOutsidePickupAndDropoff = RideErrorConstants.PICKUP_AND_DROPOFF_OUTSIDE_PICKUP_OR_DROPOFF_GEOFENCE.test(errorMessage);

      errorMessage = 'Location is not within Geofence.'

      if (pickupOutsidePickupError){
        errorMessage += ' Pick-up is outside Pick-up Geofence.';
      }

      if (dropoffOutsideDropoffError){
        errorMessage += ' Drop-off is outside Drop-off Geofence.';
      }

      if (pickupOutsidePickupAndDropoffError && !pickupOutsidePickupError ){
        errorMessage += ' Pick-up must be within Pick-up and Drop-off Geofence.';
      }

      if (dropoffOutsidePickupAndDropoffError && !dropoffOutsideDropoffError){
        errorMessage += ' Drop-off must be within Pick-up and Drop-off Geofence.';
      }

      if (pickupAndDropoffOutsidePickupAndDropoff){
        errorMessage += ' Pick-up or Drop-off must be within Pick-up or Drop-off Geofence.';
      }

    }
    return errorMessage;
  }
}
